import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup, ValidatorFn,
  Validators,
} from '@angular/forms';
import {AlertService, ConstantService} from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { MsgTemplate } from '../msg-template';
import { MsgTemplateService } from '../msg-template.service';
import {MsgService} from '@app/_components/msg';
import { PropertyService } from '@app/_components/property/property.service';
import { DevelopmentService } from '@app/_components/development/development.service';

@Component({
    selector: 'app-msg-template',
    templateUrl: './msg-template.component.html',
    styleUrls: ['./msg-template.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MsgTemplateComponent implements OnInit {
  countries: any;
  msgAudiences: any;
  properties: any[]=[];
  developments: any[]=[];
  locationIds: any[] = [];
  districts: { adrDistrict: any; }[];
  states: { adrState: any; }[];
  regions: { adrRegion: any; }[];
  buildingNames: { adrBuildingName: any; }[];
  constructor(
    private primengConfig: PrimeNGConfig,
    private msgTemplateService: MsgTemplateService,
    private alertService: AlertService,
    private messageService: MessageService,
    private formBuilder: UntypedFormBuilder,
    private propertyService: PropertyService,
    private developmentService: DevelopmentService,
    private constantService: ConstantService,
    private msgService: MsgService,
    private confirmationService: ConfirmationService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    (this.formTitle = data.title),
      (this.msgTemplate = data.msgTemplate),
      (this.statuses = msgTemplateService.statuses);
    this.communicationMediums = msgTemplateService.communicationMediums;
    this.countries = this.constantService.countries;
    this.msgTopics = msgService.msgTopics;
    this.msgAudiences = msgService.msgAudiences;
    this.locationIds = this.constantService.locations;
  }
  @Input() msgTemplate: MsgTemplate;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();
  msgTopics: any[];
  // data
  msgTemplateId: number;
  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;
  msgTemplates: any;

  statuses: any;
  communicationMediums: any;

  validationMessages = {
    msgTemplateId: [],
    name: [{ type: 'required', message: 'Required' }],
    senderName: [],
    senderEmail: [],
    senderMobileNum: [],
    senderCountryCode: [],
    subject: [{ type: 'required', message: 'Subject is required if you add email content' }],
    emailHtml: [],
    emailText: [],
    mobileText: [{
      type: 'maxlength',
      message: 'Maximum 150 characters allowed.'
    }],
    msgAudience: [],
    status: [],
    useDefaultLetterhead: [],
    opsNotes: [],
    tempEmailName: [],
    shortTermRentalId:[],
    developmentId:[],
    adrBuildingName: [],
      adrState:[],
      locationId:[],
      adrRegion:[],
      adrDistrict:[],
      communicationMediumCode:[]
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();
    this.fetchProperties();
    this.fetchDevelopments();

    // if we were passed the whole msgTemplate object
    if (this.msgTemplate) {
      this.msgTemplateId = this.msgTemplate.msgTemplateId;
      this.fixDates();
      this.fetchTemplatesById();
      // this.form1.patchValue(this.msgTemplate);
    }
    this.fetchAllTemplates();
  }

  fetchProperties() {
		try {
			this.propertyService.propertySummaryIndividualPropertyList()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
            this.buildingNames = this.getUniqueDropdownValues('adrBuildingName');
            this.districts     = this.getUniqueDropdownValues('adrDistrict');
            this.states        = this.getUniqueDropdownValues('adrState');
            this.regions       = this.getUniqueDropdownValues('adrRegion');
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  getUniqueDropdownValues(field: string): any[] {

    const uniqueValues = new Set<string>();

    this.properties.forEach((item: any) => {

        const value = item[field];

        if (value !== null && value !== undefined && value !== '') {
          uniqueValues.add(value);
        }

      });


    return Array.from(uniqueValues).map(v => ({ [field]: v }));
  }

  getPropertyList(): any[] {
    return this.properties
      .map(obj => Object.keys(obj).map(k => obj[k]))
      .reduce((a, b) => a.concat(b), []);
  }

  fetchDevelopments() {
      try {
        this.developmentService.getDevelopmentSummary().subscribe(
          (res) => {
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.developments = res.data.developments;
            return this.developments;
          },
          (err) => {
            console.log("Feature-Update FAIL: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {}
        );
      } catch (error) {
        console.log("Form Invalid: " + JSON.stringify(error));
        this.alertService.error(error);
      }
  }

  onFormDelete() {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        'Are you sure you want to delete Id# ' + this.msgTemplateId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Canceled',
          detail: 'Delete canceled.',
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.msgTemplateService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log('property-add SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message,
          });
          this.msgTemplate = res.data.msgTemplate;
          this.doAdd.emit(this.msgTemplate);
        },
        (err: any) => {
          console.log('msgTemplate-add FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log('msgTemplate: ' + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;
      this.msgTemplateService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message,
          });
          this.msgTemplate = res.data.msgTemplate;
          this.doUpdate.emit(this.msgTemplate);
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.msgTemplateService.delete(this.msgTemplate.msgTemplateId).subscribe(
        (res: any) => {
          console.log('msgTemplate-delete SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message,
          });
          this.doDelete.emit(this.msgTemplate);
        },
        (err: any) => {
          console.log('msgTemplate-add FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      msgTemplateId: [this.msgTemplateId],
      name: ['', Validators.required],
      senderName: [],
      senderEmail: [],
      senderMobileNum: [],
      senderCountryCode: [],
      subject: [],
      emailHtml: [],
      emailText: [],
      mobileText: ['', Validators.maxLength(250)],
      msgAudience: [],
      status: [0],
      useDefaultLetterhead: [],
      letterHeadTemplateId: [],
      opsNotes: [],
      tempEmailName:[],
      shortTermRentalId:[],
      developmentId:[],
      adrBuildingName: [],
      adrState:[],
      locationId:[],
      adrRegion:[],
      adrDistrict:[],
      communicationMediumCode: [1]
    }, { validators: subjectRequiredValidator() });
  }
  fetchAllTemplates() {
    if (!this.msgTemplates || this.msgTemplates === undefined || this.msgTemplates.length < 1) {
      try {
        this.msgTemplateService.findAllWithoutPage()
          .subscribe(
            res => {
              console.log('employee Profiles: ' + JSON.stringify(res));
              this.msgTemplates = res.data.msgTemplates;
              return this.msgTemplates;
            },
            err => {
              console.log('Feature-Update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => { });
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
    else {
      return (this.msgTemplates);
    }
  }

  fetchTemplatesById() {
      try {
        this.msgTemplateService.findById(this.msgTemplateId)
          .subscribe(
            res => {
              console.log('employee Profiles: ' + JSON.stringify(res));
              this.msgTemplate = res.data.msgTemplate;
              this.form1.patchValue(this.msgTemplate);
              return this.msgTemplate;
            },
            err => {
              console.log('Feature-Update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => { });
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    // this.msgTemplate.msgTemplateDate = moment(
    //   this.msgTemplate.msgTemplateDate
    // ).toDate();
  }
}
export function subjectRequiredValidator(): ValidatorFn {
  return (formGroup: AbstractControl) => {
    const emailHtml = formGroup.get('emailHtml')?.value;
    const emailText = formGroup.get('emailText')?.value;
    const subject = formGroup.get('subject')?.value;

    if ((emailHtml || emailText) && !subject) {
      formGroup.get('subject')?.setErrors({ required: true });
    } else {
      formGroup.get('subject')?.setErrors(null);
    }

    return null; // Always return null for group validators.
  };
}
